import { useTranslation } from "react-i18next"

const ImageContainer = () => {
  const { i18n } = useTranslation()

  return (
    <>
      <div
        className={`image-container`}>
        <div className={`${i18n.language === 'fa' ? 'fa' : 'en'}`}></div>
      </div>
    </>
  )
}

export default ImageContainer